import { useState } from 'react'
import { StyledAbbr } from './AbbrText.style'
import { useMemo } from 'react'

const AbbrText = ({ title, children }) => {
    const [show, setShow] = useState(false)
    const value = useMemo(() => {
        return show ? title : children
    }, [show, title, children])

    return (
        <StyledAbbr
            title={title}
            onClick={() => setShow(!show)}
        >
            {value}
        </StyledAbbr>
    )
}

export default AbbrText